<template>
  <div>
    <el-row type="flex">
      <el-col v-for="(item, index) in analyzeData" :key="index">
        <div>
          {{ item.title }}
          <el-tooltip class="item" effect="dark" placement="right">
            <div slot="content">
              {{ item.tip }}
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="box-res">
          {{ item.data }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    analyzeData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.box-res {
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
}
</style>
